<template>
  <div class="popup-selector_item" @click="$emit('show-popup')">
    <img
      alt="icon"
      :src="icon"
      :style="iconStyle"
      v-if="showIcon&&icon"
      class="popup-selector_icon j-select-icon-dcount"
    />
    <div class="popup-selector_name" :class="showIcon ? 'has-icon' : false">
      <slot></slot>
    </div>
    <i class="popup-selector_arrow icon-arrow_down j-select-arrow-dcount"></i>
  </div>
</template>

<script>
export default {
  name: 'popupSelector',
  props: {
    showIcon: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: ''
    },
    iconStyle: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
.popup-selector {
  &_item {
    height: 56px;
    display: flex;
    cursor: pointer;
    padding: 5px 7px;
    overflow: hidden\9;
    border-radius: 5px;
    line-height: 30px\9;
    align-items: center;
    box-sizing: border-box;
    border: 1px solid #c2c2c2;
    justify-content: flex-start;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
  }
  &_icon {
    float: left\9;
    width: 44px;
    height: 44px;
    flex: 0 0 44px;
    border-radius: 5px;
  }
  &_name {
    float: left\9;
    flex: 1;
    font-size: 16px;
    color: #333333;
    position: relative;
    letter-spacing: 0px;
    &.has-icon {
      padding-left: 10px;
    }
  }
  &_arrow {
    float: right\9;
    flex: 0 0 9px;
    margin-right: 10px;
    margin-top: 12px\9;
  }
}
</style>
